import { useState, useEffect } from 'react';
import { Menu } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import logo from '../img/logo.svg';
import './Header.css';

/**
 * Компонент Header - переиспользуемая шапка сайта
 * @param {Array} sections - массив секций для навигации
 * @param {Function} onJoinClick - обработчик клика на кнопку Join us
 */
const Header = ({ sections = [], onJoinClick }) => {
  const navigate = useNavigate();
  const [screenSize, setScreenSize] = useState('desktop');
  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false);

  // Отслеживание размера экрана
  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setScreenSize('mobile');
      } else if (width < 968) {
        setScreenSize('tablet');
      } else {
        setScreenSize('desktop');
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const isMobile = screenSize === 'mobile';
  const isTablet = screenSize === 'tablet';

  // Функции управления бургер-меню
  const handleMenuClick = () => setIsBurgerMenuOpen(!isBurgerMenuOpen);
  
  const handleSectionClick = (sectionId) => {
    if (sectionId.startsWith('/')) {
      // Если это путь (начинается с /), используем navigate
      navigate(sectionId);
      setIsBurgerMenuOpen(false);
    } else {
      // Если это ID секции, проверяем, на главной ли мы странице
      const element = document.getElementById(sectionId);
      if (element) {
        // Мы на главной странице, просто скроллим
        element.scrollIntoView({ behavior: 'smooth' });
        setIsBurgerMenuOpen(false);
      } else {
        // Мы не на главной странице, переходим на главную с якорем
        navigate('/', { state: { scrollTo: sectionId } });
        setIsBurgerMenuOpen(false);
      }
    }
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <>
      <header className="header">
        <div className="header-inner">
          <div className="logo-container" onClick={handleLogoClick}>
            <img
              src={logo}
              alt="Логотип Debt Agent"
              className="logo-image" 
            />
            {!isMobile && (
              <div className="logo-text">
                <span className="logo-title">DEBT AGENT</span>
                <span className="logo-subtitle">protecting your debts since 2001</span>
              </div>
            )}
          </div>

          {!isMobile && !isTablet && sections.length > 0 && (
            <nav className="header-nav">
              {sections.slice(0, 5).map((section) => (
                <button
                  key={section.id}
                  className="nav-link"
                  onClick={() => handleSectionClick(section.id)}
                >
                  {section.label}
                </button>
              ))}
            </nav>
          )}

          <div className="header-actions">
            <button className="join-button" onClick={onJoinClick}>
              Join us
            </button>

            <div className="menu-icon" onClick={handleMenuClick}>
              <Menu size={24} color="#333333" />
            </div>

            {/* Dropdown Menu - внутри header-actions */}
            {isBurgerMenuOpen && (
              <div className="dropdown-menu">
                <ul className="dropdown-menu-list">
                  <li>
                    <button
                      className="dropdown-menu-item"
                      onClick={() => handleSectionClick('/')}
                    >
                      Home Page
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-menu-item"
                      onClick={() => handleSectionClick('/terms-of-service')}
                    >
                      Terms of Service
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-menu-item"
                      onClick={() => handleSectionClick('/privacy-policy')}
                    >
                      Privacy Policy
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-menu-item"
                      onClick={() => handleSectionClick('/track-the-order')}
                    >
                      Track Order
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Overlay для закрытия меню */}
      {isBurgerMenuOpen && (
        <div className="dropdown-overlay" onClick={() => setIsBurgerMenuOpen(false)} />
      )}
    </>
  );
};

export default Header;
